// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 581 ? "main.app" : chunkId) + "." + {"581":"32f2a7fb","890":"89665e3a"}[chunkId] + ".chunk.js";
};